import * as React from 'react';
import StatsGrid from '../components/Dashboard/StatsGrid';
import FinancialAnalytics from '../components/Dashboard/FinancialAnalytics';
import { useDashboardStats } from '../hooks/useDashboardStats';
import { EnhancedLoadingSpinner } from '../components/common/EnhancedLoadingSpinner';

export default function Dashboard() {
  // Use the updated dashboard stats hook that fetches its own data
  const { loading: statsLoading, error: statsError, leaseholderStats, communityStats } = useDashboardStats();

  if (statsError) {
    return (
      <div className="p-4 bg-red-50 text-red-700 rounded-lg">
        Error loading dashboard data: {statsError.message}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Use EnhancedLoadingSpinner for loading states with auto-refresh option */}
      <EnhancedLoadingSpinner 
        isLoading={statsLoading}
        timeout={5000}
        message="Loading dashboard data..."
      />
      
      {/* Continue to pass loading to child components */}
      <StatsGrid 
        loading={statsLoading}
        leaseholderStats={leaseholderStats}
        communityStats={communityStats}
      />

      <FinancialAnalytics />
    </div>
  );
}
